import React from 'react';

// Styles & Assets
import styles from './PatientTableTimestamps.module.css';

// Hooks
import { useEffect, useState } from 'react';

// Components
import Modal from '../../UI/Modal/Modal';
import DialogVitalSigns from '../DialogVitalSigns/DialogVitalSigns';
import AddColumn from '../../UI/AddColumn/AddColumn';

// Interfaces
import { DataElementByHour } from '../../../interfaces/PhysiologicalMonitoring';
import { Parameter } from '../../../interfaces/Profile';
import { ElementsDispatch } from '../../../interfaces/Reducers';

// Other
import moment from 'moment';

const PatientTableTimestamps: React.FC<{
    parameters: Parameter[],
    data: DataElementByHour[],
    readOnly: boolean
    dispatchElements: React.Dispatch<ElementsDispatch>
}> = ({ parameters, data, readOnly, dispatchElements }) => {
    const [showVitalSignsDialog, setShowVitalSignsDialog] = useState<boolean>(false);
    const [selectedDataElement, setSelectedDataElement] = useState<DataElementByHour | null>(null);
    const [showTimestampExists, setShowTimestampExists] = useState<boolean>(false);
    const [showAnimation, setShowAnimation] = useState<boolean>(false);

    const handleClickTimestamp = (date: string) => {
        setShowVitalSignsDialog(true);
        setSelectedDataElement(data.find(timestamp => timestamp.date === date) || null);
    };

    const handleAddColumn = () => {
        const formattedDate = moment(new Date()).format('DD-MM-YYYY HH:00:00');
        if (data.length > 0 && data[0].date + ':00' === formattedDate) {
            setShowTimestampExists(true);
        } else {
            dispatchElements({ type: 'ADD_TIMESTAMP', date: formattedDate });
            setShowAnimation(true);
        }
    };

    useEffect(() => {
        if (!showAnimation) return;

        const timeout = setTimeout(() => {
            setShowAnimation(false);
        }, 500);

        return () => clearTimeout(timeout);
    }, [showAnimation]);

    return (
        <thead className={styles.header}>
            <tr>
                <th className={styles.firstColSticky}>
                    <AddColumn
                        addColumn={handleAddColumn}
                        showDialog={showTimestampExists}
                        setShowModal={setShowTimestampExists}
                    />
                </th>
                {data.map((timestamp, index) => (
                    <th
                        key={timestamp.date}
                        className={`${styles.timestampContainer} ${showAnimation && index === 0 ? styles.addColAnimation : ''}`}
                    >
                        <button
                            onDoubleClick={() => handleClickTimestamp(timestamp.date)}
                            disabled={readOnly}
                            className={styles.timestampButton}
                        >
                            <p>{timestamp.date.split(' ')[0]}</p>
                            <p className={styles.hour}>
                                {timestamp.date.split(' ')[1]}
                            </p>
                        </button>
                    </th>
                ))}
            </tr>
            {parameters && selectedDataElement && (
                <Modal show={showVitalSignsDialog} setShowModal={setShowVitalSignsDialog}>
                    <DialogVitalSigns
                        parameters={parameters}
                        dataElementHour={selectedDataElement}
                        showModal={setShowVitalSignsDialog}
                        dispatchElements={dispatchElements}
                    />
                </Modal>
            )}
        </thead>
    );
};

export default PatientTableTimestamps;